"use strict";var e=require("./types.internal.js");Object.defineProperty(exports,"FontWeight",{enumerable:!0,get:function(){return e.FontWeight}});
//# sourceMappingURL=types.js.map
